module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-700.woff?f24f4bcef8a4a0eb6345d292b85dc7fe";